import { InjectionToken } from '@angular/core'
import Echo, { EchoOptions } from 'laravel-echo'
import Pusher, { Options } from 'pusher-js'

export const BROADCAST_FACTORY = new InjectionToken<{
  echo: (options: EchoOptions<'reverb'>) => Echo<'reverb'>
  pusher: (key: string, options: Options) => Pusher
}>('Broadcast Factory')
